import { useTrivia } from '../../../../hooks';

export const TriviaPagination = () => {
  const { questions, activeQuestion, changeQuestion } = useTrivia();

  /**
   * Cambia la pregunta basado en el indice
   * @param questionIndex Indice de la pregunta que se desea cambiar
   */
  const handleChangeQuestion = (questionIndex: number) =>{
    const question = questions[questionIndex];

    if(!question) return;

    changeQuestion(question);
  }

  if(!questions){
    return(<></>)
  }

  return (
    <div className='slider-trivia'>
        <ul className="splide__pagination splide__pagination--ltr splide__pagination--dot">
          {
            questions.map((question, index) => (
              <li role="presentation" key={question.id}>
                <button
                  className={`splide__pagination__page ${activeQuestion?.id === question.id ? 'is-active' : '' }`}
                  type="button"
                  onClick={() => handleChangeQuestion(index)}
                >{ index + 1 }</button>
              </li>
            ))
          }
        </ul>
    </div>
  )
}